import * as appConfig from '../app.config';

import { BookingOfferDetailComponent } from '../components/bookings/booking-offer-detail.component';

import { BookingsComponent } from './../components/bookings/bookings.component';
import { BookingItemDetailComponent } from './../components/bookings/booking-item-detail.component';
import { BookingHolidayDetailComponent } from './../components/bookings/booking-holiday-detail.component';
import { BookingsOverviewComponent } from './../components/bookings/bookings-overview.component';
import { BookingsWindowComponent } from './../components/bookings/bookings-window.component';
import { ConfirmationComponent } from '../shared/components/modal/confirmation/confirmation.component';

const defaultRoute = {
  path: 'bookings',
  redirectTo: 'novelties'
};

const activeModuleRoutes = {
  path: 'bookings',
  data: {
    breadcrumbs: {
      label: 'Rezervace položek',
      icon: 'booking'
    },
    state: 'bookings'
  },
  children: [
    {
      path: '',
      component: BookingsComponent
    },
    {
      path: 'add',
      data: {
        breadcrumbs: {
          label: 'Přidat rezervační nabídku'
        },
        state: 'booking-offer-add'
      },
      children: [
        {
          path: '',
          component: BookingOfferDetailComponent
        }
      ]
    },
    {
      path: 'edit/:id',
      data: {
        breadcrumbs: {
          label: 'Upravit rezervační nabídku'
        },
        state: 'booking-offer-edit'
      },
      children: [
        {
          path: '',
          component: BookingOfferDetailComponent
        }
      ]
    },
    {
      path: 'delete/:id',
      component: ConfirmationComponent,
      data: {
        breadcrumbs: {
          label: 'Smazat rezervační nabídku'
        },
        state: 'booking-offers-delete',
        apiUri: 'booking-offers'
      },
      outlet: 'modal'
    },
    {
      path: 'holidays-delete/:id',
      component: ConfirmationComponent,
      data: {
        breadcrumbs: {
          label: 'Smazat prázdniny'
        },
        state: 'booking-holidays-delete',
        apiUri: 'booking-holidays'
      },
      outlet: 'modal'
    },
    {
      path: 'items-delete/:id',
      component: ConfirmationComponent,
      data: {
        breadcrumbs: {
          label: 'Smazat položku'
        },
        state: 'booking-items-delete',
        apiUri: 'booking-items'
      },
      outlet: 'modal'
    },
    {
      path: 'booking_overview/:id',
      data: {
        breadcrumbs: {
          label: 'Rezervace'
        },
        state: 'booking-overview'
      },
      children: [
        {
          path: '',
          component: BookingsOverviewComponent
        },
        {
          path: ':day',
          component: BookingsWindowComponent,
          data: {
            breadcrumbs: {
              label: 'Upravit blok rezervací'
            },
            state: 'booking-edit'
          },
          outlet: 'modal'
        }
      ]
    },
    {
      path: 'holidays/add',
      data: {
        breadcrumbs: {
          label: 'Přidat prázdniny'
        },
        state: 'holiday-add'
      },
      children: [
        {
          path: '',
          component: BookingHolidayDetailComponent
        }
      ]
    },
    {
      path: 'holidays/edit/:id',
      data: {
        breadcrumbs: {
          label: 'Upravit prázdniny'
        },
        state: 'holiday-edit'
      },
      children: [
        {
          path: '',
          component: BookingHolidayDetailComponent
        }
      ]
    },
    {
      path: 'holidays/add/:booking_offer_id',
      data: {
        breadcrumbs: {
          label: 'Přidat prázdniny'
        },
        state: 'holiday-add'
      },
      children: [
        {
          path: '',
          component: BookingHolidayDetailComponent
        }
      ]
    },
    {
      path: 'items/add',
      data: {
        breadcrumbs: {
          label: 'Přidat nabídkovou položku'
        },
        state: 'booking-item-add'
      },
      children: [
        {
          path: '',
          component: BookingItemDetailComponent
        }
      ]
    },
    {
      path: 'items/edit/:id',
      data: {
        breadcrumbs: {
          label: 'Upravit nabídkovou položku'
        },
        state: 'booking-item-edit'
      },
      children: [
        {
          path: '',
          component: BookingItemDetailComponent
        }
      ]
    },
    {
      path: 'items/add/:booking_item_id',
      data: {
        breadcrumbs: {
          label: 'Přidat nabídkovou položku'
        },
        state: 'booking-item-add'
      },
      children: [
        {
          path: '',
          component: BookingItemDetailComponent
        }
      ]
    }
  ]
};

export const bookingRoutes = appConfig.modules.bookings ? activeModuleRoutes : defaultRoute;
